import { render, staticRenderFns } from "./salesperson-vue.vue?vue&type=template&id=2f2ee018&scoped=true&"
import script from "./salesperson-vue.vue?vue&type=script&lang=js&"
export * from "./salesperson-vue.vue?vue&type=script&lang=js&"
import style0 from "./salesperson-vue.vue?vue&type=style&index=0&id=2f2ee018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ee018",
  null
  
)

export default component.exports